import Slide from '@mui/material/Slide';
import * as React from 'react';
import EmployesByEnterprise from './EmployesByEnterprise';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EmployesByEnterpriseModal({
  open,
  setOpen,
  title,
  handleClose,
  Fullscreen,
  selectedEnterprise,
}) {
  // const [open, setOpen] = React.useState(openP);

  const handleClickOpen = () => {
    setOpen(true);
  };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
    <EmployesByEnterprise
      openP={open}
      setOpenP={setOpen}
      Fullscreen={Fullscreen}
      handleClose={handleClose}
      selectedEnterprise={selectedEnterprise}
    />
  );
}
